import { rockApi, unwrapRockResponse } from "./rockApiClient";

export const rockRealOrFakeApi = {
  async getList({ page = 1, items_per_page = 50 } = {}) {
    const resp = await rockApi.get("/rocks/real-or-fake", { params: { page, items_per_page } });
    return unwrapRockResponse(resp);
    // Returns: { items: [...], objects: { total, count }, extra: {} }
  },

  async getDetail(uid) {
    const resp = await rockApi.get("/rocks/real-or-fake/detail", { params: { uid } });
    return unwrapRockResponse(resp);
  }
};
